import gql from 'graphql-tag';

// 展示PartnerTransaction接口
export const QUERY_PARTNER_TRANSACTION = gql`
  query listPartnerTransactions(
    $bookingNumbers: [String]
    $partnerIds: [ID]
    $subTypes: [PartnerTransactionSubtype]
    $pageNumber: Int
    $pageSize: Int
    $sortBy: PartnerTransactionSortBy
    $sortDirection: SortDirection
  ) {
    listPartnerTransaction(
      bookingNumbers: $bookingNumbers
      partnerIds: $partnerIds
      subTypes: $subTypes
      pageNumber: $pageNumber
      pageSize: $pageSize
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      edges {
        node {
          id
          partner {
            id
            partnerCode
            name
          }
          amount
          currency
          bookingNumber
          status
          opportunity {
            name
            createdAt
          }
          # order {
          #   id
          # }
          description {
            passportLastName
            passportFirstName
            destinationCity
            payoutStage
          }
          createdAt
          operatedByUser {
            fullName
          }
        }
      }
    }
  }
`;

// partner name 搜索接口
export const QUERY_LIST_PARTNERS = gql`
  query listPartners($name: String, $partnerCode: String) {
    listPartners(name: $name, partnerCode: $partnerCode) {
      edges {
        node {
          id
          name
          partnerCode
        }
      }
    }
  }
`;

// 上传文件接口 给Axios用的
export const MUTATION_BULK_TRANSFER_TO_PARTNER_UPLOAD_STRING = `
  mutation bulkTransferToPartnerUpload($file: Upload!) {
    bulkTransferToPartnerUpload(input: { file: $file }) {
      filename
      filePath
      totalNum
      sheetJson {
        amount
        bookingNumber
        currency
        partnerCode
        payoutStage
        passportFirstName
        passportLastName
      }
    }
  }`;

// 校验数据接口
export const QUERY_BULK_TRANSFER_TO_PARTNER_CHECK = gql`
  query bulkTransferToPartnerCheck($input: [BulkTransferToPartnerInput!]!) {
    bulkTransferToPartnerCheck(input: $input) {
      # 同一笔订单不能绑定多个student
      bookingBindMutilStudent {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              bookingNumber
              passportFirstName
              passportLastName
            }
          }
        }
      }
      # 校验订单号和学生passport信息是否匹配
      bookingNumberBindStudentCorrectly {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              bookingNumber
              dbPassportFirstName
              dbPassportLastName
              inputPassportFirstName
              inputPassportLastName
            }
          }
        }
      }
      # 校验输入的数据是否重复
      inputDataDuplication {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              bookingNumber
              payoutStage
            }
          }
        }
      }
      # 校验currency是否是受支持的
      supportedCurrency {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              currency
            }
          }
        }
      }
      # 校验partner是否存在
      partnerExistence {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              partnerCode
            }
          }
        }
      }
      # 校验partner是否绑定了国家
      partnerBindCountry {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              partnerCode
            }
          }
        }
      }
      # 校验partner绑定的国家是否存在
      partnerCountryExistence {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              countryCode
            }
          }
        }
      }
      # 校验对应payout转账是否已转
      inputDataDuplicationWithDB {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              bookingNumber
              payoutStage
            }
          }
        }
      }
      # 校验输入的订单号是否存在
      bookingNumberExistence {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              bookingNumber
            }
          }
        }
      }
      #同一笔订单不能绑定多个currency
      bookingNumberWithCurrency {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              currency
              bookingNumber
            }
          }
        }
      }
      # 校验订单号和partnerCode是否匹配
      bookingNumberWithPartnerCodeExistence {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              bookingNumber
              partnerCode
            }
          }
        }
      }
      # 校验输入currency对应的公司钱包们的余额是否够支付当前转账
      companyWalletBalance {
        checked
        success
        error {
          code
          message
          extensions {
            data {
              currency
              countryId
              transferAmount
              remainingAmount
            }
          }
        }
      }
    }
  }
`;

// 批量转账接口
export const MUTATION_BULK_TRANSFER_TO_PARTNER = gql`
  mutation bulkTransferToPartner($input: [BulkTransferToPartnerInput!]!) {
    bulkTransferToPartner(input: $input) {
      result
    }
  }
`;
